import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FlightTrip } from '../../assests/ExportImageIcon'
// FilterSidebar (flight's) is only used by the commented-out block below.
// import FilterSidebar from '../../componants/sidebar/filterSidebar'
import TrainFilterSidebar from '../../componants/sidebar/trainFilterSidebar'
import FlightDateTabs from '../flight/FlightDateTabs'
// FlightResults, and the flightFilterUtils-driven filtering state below, are
// only used by the commented-out block further down — no real train search
// API yet, so results are static (see trainResults.jsx).
// import FlightResults from '../flight/FlightResults'
// import { applyFlightFilters, buildFilterOptions, defaultFilters } from '../flight/flightFilterUtils'
import TrainResults from './trainResults'
import TrainSearchLoader from '../../componants/trainSearchLoader/TrainSearchLoader'

const SORT_TABS = [
    { key: 'price', label: 'Price', subtext: 'Low to High' },
    { key: 'fastest', label: 'Fastest', subtext: 'Shortest First' },
    { key: 'departure', label: 'Departure', subtext: 'Earliest First' },
    { key: 'smart', label: 'Smart', subtext: 'Recommendation' },
]

const TrainList = () => {
    const [sortBy, setSortBy] = useState(null)
    const results = useSelector((state) => state.trainSearch.results)
    const searchParams = useSelector((state) => state.trainSearch.searchParams)
    const isSearching = useSelector((state) => state.trainSearch.isSearching)

    // This bar only displays the criteria already searched from the train
    // home page (searchParams) — it doesn't let the user change and re-search
    // from here, so no local editable state/API call is needed.
    const fromLabel = searchParams.origin ? `${searchParams.origin.code} - ${searchParams.origin.name}` : ''
    const toLabel = searchParams.destination ? `${searchParams.destination.code} - ${searchParams.destination.name}` : ''

    const countLabel = results
        ? `${results.count} Train${results.count === 1 ? '' : 's'} Available`
        : '0 Trains Available'

    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='innerSearch bgWhite paddingCommon20 borderRadius20'>
                                <div className='innerSearchBar'>
                                    <div className='innerSearchField'>
                                        <label>From</label>
                                        <input type="text" value={fromLabel} readOnly />
                                    </div>
                                    <div className='innerSwapIcon'>
                                        <img src={FlightTrip} alt="Swap" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>To</label>
                                        <input type="text" value={toLabel} readOnly />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Departure</label>
                                        <input type="text" value={searchParams.date} readOnly />
                                    </div>
                                </div>

                                {/* No student/senior-citizen/armed-forces fare concept on /trains/train-list/ — flight-only.
                                <div className='specialFares'>
                                    <span className='specialFaresLabel'>Special Fares <span className='optional'>(Optional)</span> :</span>
                                    {searchParams.studentFare && <div className='specialFarePill'>Student</div>}
                                    {searchParams.seniorCitizen && <div className='specialFarePill'>Senior Citizen</div>}
                                    {searchParams.armedForces && <div className='specialFarePill'>Armed Forces</div>}
                                </div>
                                */}
                            </div>
                        </div>
                        <div className='col-md-12'>
                            {isSearching ? (
                                <TrainSearchLoader />
                            ) : (
                                <div className='searchListing'>
                                    <div className='filterBar'>
                                        {/* This page is still the copy-pasted flight results wiring — the sidebar
                                            below is the real train one (static, matches the reference design).
                                        <FilterSidebar
                                            options={filterOptions}
                                            filters={filters}
                                            onChange={setFilters}
                                            onReset={() => setFilters(defaultFilters(filterOptions))}
                                            fromCity={searchParams.fromAirport?.city}
                                            toCity={searchParams.toAirport?.city}
                                        /> */}
                                        <TrainFilterSidebar />
                                    </div>
                                    <div className='searchResult'>
                                        <div className='topTabFlightDate'>
                                            <FlightDateTabs />

                                            <div className='sortingCount'>
                                                <small>Sort by </small>
                                                <small>{countLabel}</small>
                                            </div>

                                            <div className='filterTabs'>
                                                {SORT_TABS.map((tab) => (
                                                    <div
                                                        key={tab.key}
                                                        className={`filterTab ${sortBy === tab.key ? 'active' : ''}`}
                                                        onClick={() => setSortBy(sortBy === tab.key ? null : tab.key)}
                                                    >
                                                        <div className='filterTab__label'>{tab.label}</div>
                                                        <div className='filterTab__subtext'>{tab.subtext}</div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className='resultFlight'>
                                                {/* <FlightResults sortBy={sortBy} flights={filteredFlights} hasRawResults={rawFlights.length > 0} /> */}
                                                <TrainResults items={results?.data} fromCode={searchParams.origin?.code} toCode={searchParams.destination?.code} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>

            </section>
        </>
    )
}

export default TrainList
